export default "__VITE_ASSET__oJxDzTCb__"